import { Field, useFormikContext } from 'formik';
import React from 'react';
import { DatePickerUI, FormErrorUI, FormLabelUI, InputUI } from '../../Interface';

const ComplaintReportD2 = ({ disabled }) => {
  const { values, errors, setFieldValue, validateField } = useFormikContext();

  return (
    <div className="grid grid-cols-12 gap-x-4">
      <div className="col-span-12">
        <Field
          type="text"
          name="issueDescription"
          as={InputUI}
          className={`${disabled ? 'rounded-md' : ''} resize-none h-36, p-2`}
          fullWidth
          label={<FormLabelUI text="Mi a probléma?" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.issueDescription} />}
          disabled={disabled}
          InputLabelProps={{ shrink: values.issueDescription && values.issueDescription !== '' }}
          multiline
          rows={6}
        />
      </div>
      <div className="col-span-12 md:col-span-6">
        <Field
          type="text"
          name="rejectedQty"
          as={InputUI}
          fullWidth
          label={<FormLabelUI text="Kifogásolt mennyiség" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.rejectedQty} />}
          disabled={disabled}
          InputLabelProps={{ shrink: values.rejectedQty && values.rejectedQty !== '' }}
        />
        <Field
          type="text"
          name="blockedQty"
          as={InputUI}
          fullWidth
          label={<FormLabelUI text="Zárolt mennyiség" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.blockedQty} />}
          disabled={disabled}
          InputLabelProps={{ shrink: values.blockedQty && values.blockedQty !== '' }}
        />
      </div>
      <div className="col-span-12 md:col-span-6">
        <Field
          type="date"
          name="productionDate"
          component={DatePickerUI}
          value={values.productionDate}
          fullWidth
          label={<FormLabelUI text="Gyártás dátuma" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.productionDate} />}
          onChange={(date) => {
            setFieldValue('productionDate', date).then(() => {
              validateField('productionDate');
            });
          }}
          disabled={disabled}
          InputLabelProps={{ shrink: values.productionDate !== '' }}
        />
        <Field
          type="text"
          name="returnedQty"
          as={InputUI}
          fullWidth
          label={<FormLabelUI text="Visszaérkezett mennyiség" />}
          variant="standard"
          helperText={<FormErrorUI message={errors.returnedQty} />}
          disabled={disabled}
          InputLabelProps={{ shrink: values.returnedQty && values.returnedQty !== '' }}
        />
      </div>
    </div>
  );
};

export default ComplaintReportD2;
